import { PublicClientApplication } from "@azure/msal-browser";
import type { Configuration } from "@azure/msal-browser";

// Check if MSAL is enabled
const isMsalEnabled = import.meta.env.VITE_MSAL_ENABLED === 'true';


// Validate environment variables only if MSAL is enabled
const requiredEnvVars = isMsalEnabled ? {
  clientId: import.meta.env.VITE_FRONTEND_APP_ID,
  tenantId: import.meta.env.VITE_TENANT_ID,
  redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
  apiClientId: import.meta.env.VITE_API_CLIENT_ID,
} : null;

// Check if required environment variables are missing (only if MSAL is enabled)
if (isMsalEnabled && requiredEnvVars) {
  const missingVars = Object.entries(requiredEnvVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    missingVars.forEach(key => {
      console.error(`  VITE_${key.toUpperCase()}`);
    });
  }

  // Additional validation for API client ID
  if (!requiredEnvVars.apiClientId) {
    console.error('VITE_API_CLIENT_ID is required for API token acquisition');
    console.error('This should be the Application (client) ID of your backend API registration');
  }

  // Log configuration for debugging
  console.log('MSAL Configuration:', {
    clientId: requiredEnvVars.clientId,
    tenantId: requiredEnvVars.tenantId,
    redirectUri: requiredEnvVars.redirectUri,
    apiClientId: requiredEnvVars.apiClientId,
    currentOrigin: window.location.origin
  });
}

export const msalConfig: Configuration | null = isMsalEnabled && requiredEnvVars ? {
  auth: {
    clientId: requiredEnvVars.clientId || '',
    authority: `https://login.microsoftonline.com/${requiredEnvVars.tenantId}`,
    redirectUri: requiredEnvVars.redirectUri,
    // Add these additional settings to help with SPA configuration
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  // Add system configuration for better SPA support
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false
  }
} : null;

// API request for acquiring tokens for your backend API
export const apiRequest = {
  scopes: [`${import.meta.env.VITE_API_CLIENT_ID}/access_as_user`]
};

// Login request for initial authentication (includes basic Microsoft Graph scopes)
export const loginRequest = isMsalEnabled ? {
  scopes: ['User.Read', 'profile', 'openid', 'email', `${import.meta.env.VITE_API_CLIENT_ID}/access_as_user`],
  // Add prompt to ensure fresh login if needed
  prompt: 'select_account'
} : null;

// Only create instance if MSAL is enabled and we have valid configuration
export const msalInstance = isMsalEnabled && msalConfig ? new PublicClientApplication(msalConfig) : null;

// Add error handling for MSAL instance (only if it exists)
// if (msalInstance) {
  // Remove the automatic handleRedirectPromise call here as it's handled in main.tsx
  // msalInstance.handleRedirectPromise().catch(error => {
  //   console.error('MSAL redirect handling error:', error);
  // });

  // Add event listeners for debugging
  // msalInstance.addEventCallback((event) => {
    
  //   if (event.eventType === 'msal:loginStart') {
  //     console.log('Login started');
  //   } else if (event.eventType === 'msal:loginSuccess') {
  //     console.log('Login successful:', event.payload);
  //   } else if (event.eventType === 'msal:loginFailure') {
  //     console.error('Login failed:', event.payload);
  //   } else if (event.eventType === 'msal:acquireTokenStart') {
  //     console.log('Token acquisition started');
  //   } else if (event.eventType === 'msal:acquireTokenSuccess') {
  //     console.log('Token acquisition successful');
  //   } else if (event.eventType === 'msal:acquireTokenFailure') {
  //     console.error('Token acquisition failed:', event.payload);
  //   }
  // });
// }
